import { xhrStatusUIState } from 'redux/reusable/xhrStatus';
import type { IState } from 'redux/state';
import { createSelector } from 'reselect';
import { initialHourSummaryState } from './hourSummary.types';

const selectHourSummaryState = (state: IState) => state.hourSummary || initialHourSummaryState;

export const readHourSummaryData = createSelector([selectHourSummaryState], hourSummaryState => {
  return {
    hourSummaries: hourSummaryState.result.map(id => hourSummaryState.entities[id]),
    ui: {
      isLoading: xhrStatusUIState(hourSummaryState.xhrStatus, 'hourSummary').isLoading,
      maybeHasMore: hourSummaryState.maybeHasMore,
    },
    totalCount: hourSummaryState.totalCount,
    columns: [
      'client',
      'num_of_Projects',
      'num_of_users',
      'total',
      ...((hourSummaryState.result[0] &&
        hourSummaryState.entities[hourSummaryState.result[0]]?.summary_info?.map(
          info => info.label
        )) ||
        []),
    ],
    projectSummaries: hourSummaryState.projectSummaries,
  };
});

export const getProjectSummaryForClient = (clientId: string) =>
  createSelector([selectHourSummaryState], hourSummaryState => {
    const clientProjects = hourSummaryState.projectSummaries[clientId];
    if (!clientProjects) return [];
    return clientProjects.result.map(id => clientProjects.entities[id]);
  });
